import { render } from "./ClassListTable.vue?vue&type=template&id=1f43c390&scoped=true&ts=true"
import script from "./ClassListTable.vue?vue&type=script&lang=ts"
export * from "./ClassListTable.vue?vue&type=script&lang=ts"

import "./ClassListTable.vue?vue&type=style&index=0&id=1f43c390&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f43c390"]])

export default __exports__